import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import SamruddhiImage from './landing_background.png';
import BjpLogo from './BJP-logo.png';
import Autocomplete from './Autocomplete';
// import mapboxgl from 'mapbox-gl';
import './Map.css';
import Loader from './Loader';
import LatlongLogo from './Latlong-Logo.png';
import 'mapbox-gl/dist/mapbox-gl.css';
import maplibregl from 'maplibre-gl';

// eslint-disable-next-line import/no-webpack-loader-syntax
maplibregl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
// mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

var cleanUp;

const Map = (props) => {
  const mapContainer = useRef(null);
  const [clickedFeature, setClickedFeature] = useState(null);
  const [stateData, setStateData] = useState([]);
  const [childData, setChildData] = useState([]);
  const [parentData, setParentData] = useState([]);
  const [count, setCount] = useState(0);
  const [mapCount, setMapCount] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [areaOrder, setAreaOrder] = useState(null);
  const [stylesLoaded, setStylesLoaded] = useState(false)
  const [sourceLoaded, setSourceLoaded] = useState(false);
  let map = useRef();
  let setVideos = props.setVideos;
  let setShareData = props.setShareData;
  let setBeneficiaryData = props.setBeneficiaryData;
  let setSchemeData = props.setSchemeData;
  let setManifestoData = props.setManifestoData;
  let setInititalUI = props.setInititalUI;
  let initialUI = props.initialUI;
  let setOpen = props.setOpen;
  let setVideosLoading = props.setVideosLoading;
  let setBeneficiaryLoading = props.setBeneficiaryLoading;
  let setSchemeLoading = props.setSchemeLoading;
  let areaId = props.areaId;
  let setAreaId = props.setAreaId;
  let stateId = props.stateId;
  let setStateId = props.setStateId;
  let setIsModalOpen = props.setIsModalOpen;

  useLayoutEffect(() => {

    if (map.current) {
      return;
    }

    map.current = new maplibregl.Map({
      container: 'map',
      zoom: 3.1,
      minZoom: 3,
      maxZoom: 18,
      center: [82.71, 23.31],
      // style: 'mapbox://styles/mapbox/streets-v11',
      style: 'https://tiles.latlong.in/openmapstyle.json',
      // style:'https://tiles.latlong.in/map/styles/openmapstyle.json'
    });
    map.current.resize();

    const attributionHTML = `
      <div class="custom-attribution">
      <a href="https://www.latlong.ai/" target="_blank" rel="noopener noreferrer"> Map Data & Tiles by <img style="" src="${LatlongLogo}" alt="Latlong Logo"> </a>
      </div>
  `;

    // map.current.addControl(new mapboxgl.AttributionControl({
    //   customAttribution: attributionHTML
    // }));

    map.current.addControl(new maplibregl.AttributionControl({
      customAttribution: attributionHTML
    }));


    const popup = new maplibregl.Popup({
      closeButton: false,
      closeOnClick: false
    })


    map.current.on('load', () => {
      //state_level
      map.current.addSource('state_level', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': stateData
        }
      });

      map.current.addLayer({
        'id': 'state_level_layer',
        'type': 'fill',
        'source': 'state_level', // reference the data source
        'layout': {},
        'maxzoom': 8,
        'minzoom': 3,
        'paint': {
          'fill-color': '#0080ff', // blue color fill
          'fill-opacity': 0.5
        }
      });

      map.current.addLayer({
        'id': 'state_level_outline',
        'type': 'line',
        'source': 'state_level',
        'layout': {},
        'maxzoom': 8,
        'minzoom': 3,
        'paint': {
          'line-color': '#000',
          'line-width': 3
        }
      });

      //child level
      map.current.addSource('child_level', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': childData
        }
      });

      map.current.addLayer({
        'id': 'child_level_layer',
        'type': 'fill',
        'source': 'child_level', // reference the data source
        'layout': {},
        'maxzoom': 18,
        'minzoom': 8,
        'paint': {
          'fill-color': '#0080ff', // blue color fill
          'fill-opacity': 0.5
        }
      });

      map.current.addLayer({
        'id': 'child_level_outline',
        'type': 'line',
        'source': 'child_level',
        'layout': {},
        'maxzoom': 18,
        'minzoom': 8,
        'paint': {
          'line-color': '#000',
          'line-width': 3
        }
      });

      // parent level
      map.current.addSource('parent_level', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': parentData
        }
      });

      map.current.addLayer({
        'id': 'parent_level_layer',
        'type': 'fill',
        'source': 'parent_level', // reference the data source
        'layout': {},
        'maxzoom': 5,
        'minzoom': 3,
        'paint': {
          'fill-color': '#0080ff', // blue color fill
          'fill-opacity': 0.5
        }
      });

      map.current.addLayer({
        'id': 'parent_level_outline',
        'type': 'line',
        'source': 'parent_level',
        'layout': {},
        'maxzoom': 5,
        'minzoom': 3,
        'paint': {
          'line-color': '#000',
          'line-width': 3
        }
      });

      setStylesLoaded(true)
      setSourceLoaded(true)


      // map.current.on('click', 'state_level_layer', (e)=>{
      //   console.log(e.features[0], 'mapclick');
      // });
      // map.current.on('mousemove', 'child_level_layer', (e) => {
      //   console.log(e.features[0])
      //   map.current.getCanvas().style.cursor = 'pointer';
      //   popup
      //     .setLngLat(e.features[0].properties.centroid.geometry.coordinates)
      //     .setHTML('hi!')
      //     .addTo(map);
      // });
      // map.current.on('click', 'child_level_layer', (e)=>{
      //   console.log(e.features[0], 'mapclick');
      //   console.log(e.features[0].properties.aa_id, e.features[0].properties.area_name, 'mapclick aa_id');
      //   setClickedFeature(e.features[0].properties.aa_id);
      // });

    });

  }, [stateData])

  useEffect(() => {
    try {
      map.current.on('styles.load', (e) => {
        setStylesLoaded(true)
      })
      map.current.on('sourcedata', (e) => {
        setSourceLoaded(true)
      })
      const parent_source = map.current.getSource("parent_level");
      parent_source.setData({
        'type': 'FeatureCollection',
        'features': parentData
      });
      const child_source = map.current.getSource("child_level");
      child_source.setData({
        'type': 'FeatureCollection',
        'features': childData
      })
      const state_source = map.current.getSource("state_level");
      state_source.setData({
        'type': 'FeatureCollection',
        'features': stateData
      });
    } catch (error) {
      console.log(error.message)

    }
  }, [stateData, childData, parentData])

  return (
    <div className={`map-container-parent ${initialUI ? 'initialUI' : ''}`}>
      {/* {initialUI && <div><div className='blur-background'><img src={SamruddhiImage}></img></div><div className='latlong-watermark'><img src={LatlongLogo}></img><h5>AALOKA</h5></div><div className='bjp_logo'><img src={BjpLogo}></img></div></div>}  */}
      <div className="map-container" id='map' ref={mapContainer}>
        {showLoader && <Loader />}
        {/* {!initialUI && <div><div className='latlong-watermark'><img src={LatlongLogo}></img></div><div className='bjp_logo'><img src={BjpLogo}></img></div></div>} */}
      </div>
      {
        stylesLoaded && sourceLoaded &&
        <Autocomplete map={map} setOpen={setOpen} setAreaOrder={setAreaOrder} clickedFeature={clickedFeature} setStateData={setStateData} setChildData={setChildData} setParentData={setParentData} setShowLoader={setShowLoader} stateData={stateData} setVideos={setVideos} setBeneficiaryData={setBeneficiaryData} setInititalUI={setInititalUI} setSchemeData={setSchemeData} setManifestoData={setManifestoData} setShareData={setShareData} setVideosLoading={setVideosLoading} setBeneficiaryLoading={setBeneficiaryLoading} setSchemeLoading={setSchemeLoading} areaId={areaId} setAreaId={setAreaId} stateId={stateId} setStateId={setStateId} setIsModalOpen={setIsModalOpen} />
      }
    </div>
  );
};

export default Map;
